import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TAddCommentAppendSucceed, EAddCommentActionType, IAddCommentAppendSucceedParams } from './types';

export const addCommentAppendSucceed: (data: IAddCommentAppendSucceedParams) => TAddCommentAppendSucceed =
  actionGenerator<EAddCommentActionType.AppendSucceed, IAddCommentAppendSucceedParams>(
    EAddCommentActionType.AppendSucceed,
  );
